"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT = exports.Method = void 0;
var Method;
(function (Method) {
    Method["PAGE"] = "page";
    Method["TRACK"] = "track";
    Method["IDENTIFY"] = "identify";
    Method["GROUP"] = "group";
    Method["READY"] = "ready";
})(Method || (exports.Method = Method = {}));
exports.PRODUCT = 'Flex';
//# sourceMappingURL=telemetry.js.map